import { useDeploymentType } from "./use-deployment-type.ts";
import { useFeatureFlagGate } from "./use-feature-flag-gate.ts";
import { useIsVendor } from "./use-is-vendor.ts";

export const useSharedListsAccess = () => {
	const { isInternal } = useDeploymentType();
	const { isVendor, isLoading, isError } = useIsVendor();
	const { isReady: isFlagReady, isEnabled: isFlagEnabled } = useFeatureFlagGate(
		"traxLtlVendorCustomerAccess",
	);
	const isVendorFlagLoading =
		!isInternal && isVendor && !isError && !isFlagReady;
	const isAccessLoading = !isInternal && (isLoading || isVendorFlagLoading);

	return {
		canManageSharedLists:
			isInternal ||
			(!isAccessLoading && !isError && (!isVendor || isFlagEnabled)),
		isLoading: isAccessLoading,
	};
};
